const SvgBigChevronRight = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 14 32">
    <path d="M13.49 15.882.784 31.764l-.49-.392 12.392-15.49L.294.392.784 0z" />
  </svg>;
export default SvgBigChevronRight;